import type { AxiosInstance, AxiosResponse, AxiosError } from 'axios'
import type { AxiosDataResponse, ApiResponse } from '../../../config/api-types'
import { COLLECTION_ORDER_ENDPOINTS } from '../../../config/endpoints'
import type { IGetCollectionOrderStatusClient } from '../data/data-sources/i-get-collection-order-status-client'
import type { GetCollectionOrderStatusRequest } from '../domain/models/get-collection-order-status'

export class GetCollectionOrderStatusService
  implements IGetCollectionOrderStatusClient
{
  constructor(private readonly axios: AxiosInstance) {}

  async getStatus(
    params: GetCollectionOrderStatusRequest,
  ): Promise<ApiResponse> {
    try {
      const result: AxiosResponse<AxiosDataResponse> = await this.axios.get(
        `${COLLECTION_ORDER_ENDPOINTS.getStatus}/${params.collectionOrderId}`,
      )

      return {
        success: result.data.success,
        data: result.data.data,
        message: result.data.message,
        status: result.status,
      }
    } catch (error: any) {
      const axiosError = error as AxiosError<AxiosDataResponse>
      return {
        success: false,
        message: axiosError.response?.data?.message,
        status: axiosError.response?.status!,
      }
    }
  }
}
